import React from 'react';

const SimpleVideoSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        {/* Heading */}
        <div className="flex flex-wrap items-center justify-center md:justify-between mb-8">
          <h1 className="text-3xl font-semibold text-gray-800">
            Live Inaugural Function (8th-Nov-2025 9:00 AM to 11:00 AM)
          </h1>
        </div>

        {/* Video */}
        <div className="flex flex-wrap items-center justify-center md:justify-between">
          <div className="w-full aspect-video">
            <iframe
              width="100%"
              className="aspect-video rounded-lg shadow-lg"
              height="auto"
              // src="https://www.youtube.com/embed/DOhSKrzJ1_M"
              src="https://www.youtube.com/embed/Ahd7apvlD2s"
              title="IITD Open House 2025"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default SimpleVideoSection;